import React, { useEffect } from "react";
import { Bars4Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useSelector, useDispatch } from "react-redux";

import Logo from "../../assets/images/logo.png";
import { useTranslation } from "react-i18next";
import CustomMenu from "./customMneu";
import NotificationButton from "./notificationList";
import { getAddressesByUserId } from "../../redux/reducer/userAddressReducer";
import CustomDropDownNavBarCurrancy from "./customDropDownCurrancy";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

const HeaderDashboard = () => {
  const { t, i18n } = useTranslation();
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 1024);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const { addresses, loading, error } = useSelector(
    (state) => state.userAddress
  );
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateWithLang = useLanguageNavigate();
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "en";
    i18n.changeLanguage(savedLanguage);
    document.documentElement.dir = savedLanguage === "ar" ? "ltr" : "rtl";
  }, [i18n]);

  const logoStyle = {
    height: isMobile ? "40px" : "60px",
    width: isMobile ? "100px" : "161px",
  };

  const accessToken = localStorage.getItem("accessToken");
  useEffect(() => {
    if (accessToken) {
      dispatch(getAddressesByUserId());
    }
  }, [dispatch]);

  const handleClick = (e) => {
    e.preventDefault();
    navigateWithLang("/");
  };

  return (
    <div className="fixed top-0 left-0 z-50 w-full px-4 py-2 text-white bg-black shadow-md ">
      <div className="flex flex-row items-center justify-between">
        {/* Icons Section */}
        <div className="flex items-center justify-center gap-2 space-x-4 md:gap-5">
          {/* Mobile Menu Button */}
          {isMobile && (
            <button onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? (
                <XMarkIcon className="w-8 h-8 text-white" />
              ) : (
                <Bars4Icon className="w-8 h-8 text-white" />
              )}
            </button>
          )}

          <CustomMenu addresses={addresses} />

          <NotificationButton
            notification={addresses?.notification}
            userRole={addresses?.user?.role}
          />
          <div className="hidden lg:flex">
            <CustomDropDownNavBarCurrancy />
          </div>
          {/* <LanguageToggleButton /> */}
        </div>

        {/* Logo Section */}
        <div>
          <a
            href="/"
            // onClick={() => navigateWithLang("/")}
            onClick={handleClick}
          >
            <img src={Logo} alt="Logo" style={logoStyle} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeaderDashboard;
